// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"HouseholdPointsList--next-sr-only--11MlBwK","dialog":"HouseholdPointsList--dialog--WIgjK9P"};